/** Shared RBAC role identity — used by schemas and UI (keep out of page modules). */

export type Role =
  | 'unify-admin'
  | 'unify-assistant'
  | 'practice-owner'
  | 'practice-admin'
  | 'practice-assistant'
  | 'supervisor'
  | 'provider'
  | 'client';

export const ROLE_LABELS: Record<Role, string> = {
  'unify-admin': 'Unify Admin',
  'unify-assistant': 'Unify Assistant',
  'practice-owner': 'Practice Owner',
  'practice-admin': 'Practice Admin',
  'practice-assistant': 'Practice Assistant',
  supervisor: 'Supervisor',
  provider: 'Provider',
  client: 'Client',
};
